import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import { validateCustomerForm } from '../../utils/validators/validateForm';
import { NotificationManager } from 'react-notifications';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import HOCSectionLoader from '../../components/HOC/HOCSectionLoader.jsx';
import ReactCrop from 'react-image-crop';
import Dropzone from 'react-dropzone';
import 'react-image-crop/dist/ReactCrop.css';
import { Paper } from '@material-ui/core';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ROLE_PROVIDER, ROLE_CUSTOMER } from '../../utils/config/constants';
import DateTimePanel from '../../components/Providers/DateTimePanel';
import moment from 'moment';
const handleDropRejected = (...args) =>
    NotificationManager.error(
        <FormattedMessage
            id="errorUploading"
            defaultMessage="Unable to upload this picture, try another"
        />,
        'Error'
    );
class UpdateProfile extends React.Component {
    constructor(props) {
        super();
        this.state = {
            error: '',
            nameError: '',
            emailError: '',
            email: props.user.email,
            name: props.user.name,
            phone: props.user.phone,
            phoneError: '',
            loader: false,
            loaderButton: false,
            pass: false,
            noResponse: false,
            errorMessage: '',
            preview: null,
            generalPhotos: '',
            status: 1,
            crop: {
                aspect: 1 / 1
            },
            is_blocked: false,
            is_deleted: false,
            customerDetail: '',
            existingImage: '',
            files: [],
            showOld: true,
            websiteError: '',
            website: props.user.website,
            description: props.user.description,
            descriptionError: '',
            dateTimeValue: moment(parseInt(props.user.establishedOn)),
            typeId: props.user.type_id,
            businessName: props.user.businessName,
            businessNameError: '',
            language: props.user.language.language
        };

        this.handleDrop = this.handleDrop.bind(this);
    }

    submit = () => {
        const {
            name,
            email,
            phone,
            dateTimeValue,
            website,
            description,
            typeId,
            businessName,
            language, is_website
        } = this.state;

        if (validateCustomerForm({ name, email, phone }, this.handleError)) {
            this.setState({ loaderButton: true });
            if (this.props.user.role == ROLE_PROVIDER) {
                this.props.proUpdateProfileAction(
                    {
                        id: this.props.user.id,
                        name,
                        email,
                        phone,
                        image: this.state.croppedImageUrl,
                        website,
                        description,
                        typeId,
                        establishedOn: dateTimeValue,
                        businessName: businessName,
                        language,
                        is_website
                    },
                    this.onDone
                );
            } else {
                this.props.updateProfileAction(
                    {
                        id: this.props.user.id,
                        name,
                        email,
                        phone,
                        image: this.state.croppedImageUrl,
                        language
                    },
                    this.onDone
                );
            }
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="Validation Error"
                    defaultMessage="Validation Error"
                />,
                'Oops!'
            );
        }
    };
    handleError = params => {
        this.setState(params);
    };

    handleChangeLanguage = event => {
        this.setState({ [event.target.name]: event.target.value });
        this.props.changeLanguageAction({ language: event.target.value });
        document.documentElement.lang = event.target.value;
    };

    onDone = (success, data) => {
        this.setState({ loaderButton: false });
        if (success) {
            NotificationManager.success(
                <FormattedMessage
                    id="profileUpdatedSuccess"
                    defaultMessage="Profile Updated Successfully"
                />,
                'Success'
            );
            //this.props.getLoggedInUserAction();
            this.props.updateDone();
        } else {
            NotificationManager.error(data, 'Error');
        }
    };
    renderButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        }
        return (
            <button

                className="custom-button"
                onClick={this.submit}
            >
                <FormattedMessage
                    id="customer.update"
                    defaultMessage="update"
                />
            </button>
        );
    };
    handleDrop(files) {

        this.setState({
            files: this.state.files.concat(files.map(file =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file)
                })
            )),
            showOld: false
        });
    }

    onImageLoaded = (image, pixelCrop) => {
        this.imageRef = image;
    };
    onCropComplete = async (crop, pixelCrop) => {
        if (crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                pixelCrop,
                'newFile.jpeg'
            );
            this.setState({ croppedImageUrl });
        }
    };

    getCroppedImg(image, pixelCrop, fileName) {
        const canvas = document.createElement('canvas');

        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            pixelCrop.width,
            pixelCrop.height
        );

        return new Promise((resolve, reject) => {
            this.fileUrl = canvas.toDataURL('image/jpeg');
            resolve(this.fileUrl);
        });
    }
    onChangeDate = event => {
        const dateTimeValue = moment(event).format('MM-DD-YYYY');
        this.setState({ dateTimeValue: dateTimeValue });
    };
    handleChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };
    render() {
        var tomorrow = moment().add(1, 'day');
        var valid = function (current) {
            return current.isBefore(tomorrow);
        };
        console.log("Filessss::::", this.state.files)
        const thumbs = this.state.files.map((file, index) => {
            return (
                <div key={index}>
                    <h5>
                        <FormattedMessage
                            id="customer.originalimage"
                            defaultMessage="Original Image"
                        />
                    </h5>
                    <ReactCrop
                        src={file.preview}
                        imageStyle={{
                            maxHeight: "100%"
                        }}
                        onImageLoaded={this.onImageLoaded}
                        onComplete={this.onCropComplete}
                        crop={this.state.crop}
                        onChange={crop => {
                            this.setState({ crop });
                        }}
                    

                    />
                    <h5 className="pt-2">
                    <FormattedMessage
                        id="CropImage"
                        defaultMessage="Plz select and  Crop Image"
                    />
                </h5>
                </div>
            )
        });

        const { user } = this.props;
        const { formatMessage } = this.props.intl;
        const {
            emailError,
            nameError,
            phoneError,
            croppedImageUrl,
            loaderButton,
            existingImage,
            showOld,
            websiteError,
            website,
            description,
            descriptionError,
            dateTimeValue,
            typeId,
            businessName,
            businessNameError
        } = this.state;
        return (
            // <HOCSectionLoader loading={this.state.loader}>
            <div className="row">
                <div className="col-md-12 hom-cre-acc-right">
                    <form
                        className="form-new"
                        noValidate
                        autoComplete="off"
                        id="update-profile"
                    >
                        <div className="row update-profile-drop">
                            {showOld && (
                                <div className="col-md-4">
                                    {user.image && (
                                        <div>
                                            <h5>
                                                <FormattedMessage
                                                    id="customer.existingimage"
                                                    defaultMessage="Existing Image"
                                                />
                                            </h5>
                                            <img
                                                alt="existingImage"
                                                src={
                                                    user.role == ROLE_CUSTOMER
                                                        ? user.image.medium
                                                        : user.proImage.medium
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className="col-md-4">
                                <h5>
                                    <FormattedMessage
                                        id="customer.drop"
                                        defaultMessage="Drop Image here to Upload"
                                    />
                                </h5>
                                <div className="drop-box">
                                    <Dropzone
                                        onDrop={this.handleDrop}
                                        accept="image/jpeg,image/jpg,image/png"
                                        multiple={false}
                                        maxSize={2097152}
                                        onDropRejected={handleDropRejected}
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <div {...getRootProps()}>
                                                <input {...getInputProps()} />
                                                <p>
                                                    <FormattedMessage
                                                        id="customer.dropfiles"
                                                        defaultMessage="Drop files here, or click to select files"
                                                    />
                                                </p>
                                            </div>
                                        )}
                                    </Dropzone>
                                </div>
                            </div>
                            {thumbs.length > 0 && (
                                <div className="col-md-4">{thumbs}</div>
                            )}
                            <div className="col-md-4">
                                {croppedImageUrl && (
                                    <div>
                                        <h5>
                                            <FormattedMessage
                                                id="customer.finalimage"
                                                defaultMessage="Final Image"
                                            />
                                        </h5>
                                        <img alt="Crop" src={croppedImageUrl} />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="form-inner-new">
                            <div className="row">
                                <div className="col-md-4 col-xs-12">
                                    <TextField
                                        error={nameError ? true : false}
                                        helperText={nameError}
                                        type="text"
                                        name="name"
                                        className="login-form-textfield"
                                        label={formatMessage({
                                            id: 'name'
                                        })}
                                        id="name"
                                        fullWidth
                                        placeholder={formatMessage({
                                            id: 'addName'
                                        })}
                                        margin="normal"
                                        onChange={event => {
                                            this.setState({
                                                name: event.target.value,
                                                nameError: ''
                                            });
                                        }}
                                        defaultValue={user.name}
                                        disabled={loaderButton ? true : false}
                                    />
                                </div>
                                <div className="col-md-4 col-xs-12">
                                    <TextField
                                        error={emailError ? true : false}
                                        helperText={emailError}
                                        type="email"
                                        name="email"
                                        label={formatMessage({
                                            id: 'customer.email'
                                        })}
                                        id="email"
                                        fullWidth
                                        className="login-form-textfield"
                                        placeholder={formatMessage({
                                            id: 'addEmail'
                                        })}
                                        onChange={event => {
                                            this.setState({
                                                email: event.target.value,
                                                emailError: ''
                                            });
                                        }}
                                        margin="normal"
                                        defaultValue={user.email}
                                        disabled={false}
                                    />
                                </div>
                                <div className="col-md-4 col-xs-12">
                                    <TextField
                                        error={phoneError ? true : false}
                                        helperText={phoneError}
                                        type="text"
                                        name="phone"
                                        className="login-form-textfield"
                                        label={formatMessage({
                                            id: 'phone'
                                        })}
                                        id="phone"
                                        fullWidth
                                        placeholder={formatMessage({
                                            id: 'addPhone'
                                        })}
                                        disabled
                                        onChange={event => {
                                            this.setState({
                                                phone: event.target.value,
                                                phoneError: ''
                                            });
                                        }}
                                        margin="normal"
                                        defaultValue={user.phone}
                                        // disabled={loaderButton ? true : false}
                                       
                                    />
                                </div>
                                {user.role == ROLE_PROVIDER && (
                                    <React.Fragment>
                                        {/*  <div className="col-md-4 col-xs-12">
                                            <TextField
                                                error={
                                                    websiteError ? true : false
                                                }
                                                helperText={websiteError}
                                                type="text"
                                                name="website"
                                                label={formatMessage({
                                                    id: 'website'
                                                })}
                                                className="login-form-textfield"
                                                id="website"
                                                fullWidth
                                                placeholder={formatMessage({
                                                    id: 'website'
                                                })}
                                                onChange={event => {
                                                    this.setState({
                                                        website:
                                                            event.target.value,
                                                        websiteError: ''
                                                    });
                                                }}
                                                margin="normal"
                                                defaultValue={user.website}
                                                disabled={
                                                    loaderButton ? true : false
                                                }
                                            />
                                        </div> */}
                                        {user.role == ROLE_PROVIDER && user.account_type == "2" && <div className="col-md-4 col-xs-12">
                                            <TextField
                                                error={
                                                    businessNameError
                                                        ? true
                                                        : false
                                                }
                                                helperText={businessNameError}
                                                type="text"
                                                name="businessName"
                                                label={formatMessage({
                                                    id: 'businessName'
                                                })}
                                                className="login-form-textfield"
                                                id="businessName"
                                                fullWidth
                                                placeholder={formatMessage({
                                                    id: 'businessName'
                                                })}
                                                onChange={event => {
                                                    this.setState({
                                                        businessName:
                                                            event.target.value,
                                                        businessNameError: ''
                                                    });
                                                }}
                                                margin="normal"
                                                defaultValue={user.businessName}
                                                disabled={
                                                    loaderButton ? true : false
                                                }
                                            />
                                        </div>}

                                        {/* <div className="col-md-4 col-xs-12">
                                            <div className="login-form-textfield text-date">
                                                <DateTimePanel
                                                    isValidDate={valid}
                                                    timeFormat={false}
                                                    onChange={this.onChangeDate}
                                                    value={
                                                        this.state.dateTimeValue
                                                    }
                                                    defaultValue={
                                                        this.state.dateTimeValue
                                                    }
                                                />
                                            </div>
                                        </div> */}
                                        {/* <div className="col-md-4 col-xs-12 row">
                                        <Checkbox
                                            checked={typeId}
                                            onChange={this.handleChange(
                                                'typeId'
                                            )}
                                            value="typeId"
                                        />
                                        <p>Provider as a Company?</p>
                                    </div> */}
                                        <div className="col-md-12 col-xs-12">
                                            <TextField
                                                error={
                                                    descriptionError
                                                        ? true
                                                        : false
                                                }
                                                helperText={descriptionError}
                                                type="text"
                                                name="description"
                                                label={formatMessage({
                                                    id: 'description'
                                                })}
                                                id="description"
                                                fullWidth
                                                className="login-form-textfield"
                                                placeholder={formatMessage({
                                                    id: 'description'
                                                })}
                                                onChange={event => {
                                                    this.setState({
                                                        description:
                                                            event.target.value,
                                                        descriptionError: ''
                                                    });
                                                }}
                                                margin="normal"
                                                defaultValue={user.description}
                                                disabled={
                                                    loaderButton ? true : false
                                                }
                                            />
                                        </div>
                                    </React.Fragment>
                                )}

                                <div className="col-md-12 col-xs-12 d-flex justify-content-center">
                                    <div className="mt-3" />
                                    {this.renderButton()}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            // </HOCSectionLoader>
        );
    }
}

export default connect(null, actions)(injectIntl(UpdateProfile));



// WEBPACK FOOTER //
// ./src/views/User/UpdateProfile.jsx